export enum RegionsEnum {
    NA="na",
    EU="eu"
}
